import styled from "styled-components";

export const CMArtistMomentum = styled.div(({ theme }) => ({
  margin: "40px 0",
  "& .artist-stage": {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    [theme.breakpoints.lg]: {},
    [theme.breakpoints.md]: {
      flexDirection: "column",
    },
    [theme.breakpoints.sm]: {
      flexDirection: "column",
    },
  },
}));

export const CMArtistStageChart = styled.div(({ theme }) => ({
  flex: 1,
  marginTop: "10px",

  [`@media (min-width: 2000px)`]: {
    width:"10vh",
  },

  "& .chart-title": {
    marginBottom: "10px",
    textAlign: "center",

    "& h6": {
      fontWeight: 700,
      display: "inline",
      position: "relative",
      fontFamily: "Inter, sans-serif",

      "& .tooltip": {
        top: "2px",
        position: "absolute",
        left: "calc(100% + 0.5rem)",
      },
      [`@media (min-width: 2000px)`]: {
        fontSize:"2vh",
      },
    },
    "& svg": {
      [`@media (min-width: 2000px)`]: {
        width:"1.5vh",
        height:"1.5vh",
      },
    }
  },

  "& .chart-content": {
    display: "flex",
    justifyContent: "center",


    "& .chart-inner": {
      display: "flex",
      alignItems: "center",
      width: "310px",
      [`@media (min-width: 2000px)`]: {
        width: "100%"
      },

      "& .chart-size": {
        width: "calc(100% - 120px)",
        height: "180px",
        [`@media (min-width: 2000px)`]: {
          height: "20vh"
        },
        [theme.breakpoints.lg]: {
          width: "calc(100% - 100px)",
        },
        [theme.breakpoints.md]: {
          width: "calc(40%)",
        },
        [theme.breakpoints.xs]: {
          width: "calc(50%)",
        },
        [theme.breakpoints.xss]: {
          width: "calc(60%)",
        },
      },

      "& .chart-label": {
        height: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "& span": {
          background: "#f0f6ff",
          borderRadius: "6px",
          color: "#1c64f2",
          fontSize: "14px",
          fontWeight: "700",
          padding: "3px 6px",
          whiteSpace: "nowrap",
          fontFamily: "Inter, sans-serif",
          [`@media (min-width: 2000px)`]: {
            fontSize: "1.5vh",
          },
        },
      },
    },
  },

  "& .chart-options": {
    paddingTop: "0",
    marginLeft: "0",

    "& div": {
      color: "#515151",
      fontSize: "13px",
      lineHeight: "15px",
      marginBottom: "4px",
      position: "relative",
      fontFamily: "Inter, sans-serif",

      [`@media (min-width: 2000px)`]: {
        fontSize:"1.8vh",
        marginBottom:"2vh",
        width:"10vw",
      },

      "&.active": {
        fontWeight: 600,
        color: "#1c64f2",
      },

      "& img": {
        top: "2px",
        left: "-1.5rem",
        position: "absolute",
      },
    },
    
  },
}));
